import AIChatMain from './src/main.vue'

AIChatMain.install = Vue => {
  Vue.component(AIChatMain.name, AIChatMain)
}

export default AIChatMain
